// src/Library/Library.js
import { useState, useEffect } from "react";
import Bookshelf from "./Bookshelf"; // Ensure this line is correct
import "./Library.css";

function splitContentIntoPages(content) {
  return content
    .split("\n\n")
    .map(page => page.trim())
    .filter(page => page);
}

function Library() {
  const [user, setUser] = useState(null);
  const [books, setBooks] = useState([]);

  const [showCreateModal, setShowCreateModal] = useState(false);

  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [datePublished, setDatePublished] = useState("");
  const [isbn, setIsbn] = useState("");
  const [content, setContent] = useState("");

  const [editingBookId, setEditingBookId] = useState(null);

  useEffect(() => {
    const loggedIn = JSON.parse(localStorage.getItem("loggedInUser"));
    setUser(loggedIn || null);

    const storedBooks = JSON.parse(localStorage.getItem("libraryBooks")) || [];
    setBooks(storedBooks);
  }, []);

  if (!user) {
    return (
      <div className="library-guest-message">
        <h2>You must log in to view the library.</h2>
      </div>
    );
  }

  const handleSaveBook = () => {
    if (!title.trim() || !author.trim() || !content.trim()) {
      alert("Please fill in Title, Author, and Content.");
      return;
    }

    const pages = splitContentIntoPages(content);

    const newBook = {
      id: editingBookId || Date.now(),
      title: title.trim(),
      author: author.trim(),
      datePublished,
      isbn: isbn.trim(),
      pages,
    };

    const updatedBooks = editingBookId
      ? books.map((b) => (b.id === editingBookId ? newBook : b))
      : [...books, newBook];

    setBooks(updatedBooks);
    localStorage.setItem("libraryBooks", JSON.stringify(updatedBooks));

    setTitle("");
    setAuthor("");
    setDatePublished("");
    setIsbn("");
    setContent("");
    setEditingBookId(null);
    setShowCreateModal(false);
  };

  const handleEditBook = (book) => {
    setTitle(book.title);
    setAuthor(book.author);
    setDatePublished(book.datePublished);
    setIsbn(book.isbn);
    setContent(book.pages.join("\n\n\n"));
    setEditingBookId(book.id);
    setShowCreateModal(true);
  };

  const handleRemoveBook = () => {
    alert("Remove Book feature not implemented yet.");
  };
  const handleLockBook = () => {
    alert("Lock Book feature not implemented yet.");
  };
  const handleUnlockBook = () => {
    alert("Unlock Book feature not implemented yet.");
  };

  return (
    <div className="library-container">
      <h2 className="library-title">My Library</h2>

      {books.length === 0 && (
        <div className="empty-shelf-message">No books yet – coming soon!</div>
      )}

      {/* FIXED HERE: Pass books correctly via prop */}
      <Bookshelf books={books} user={user} onEditBook={handleEditBook} />

      {user.accountType === "Assistant" && (
        <div className="assistant-library-controls">
          <button className="assistant-btn" onClick={() => setShowCreateModal(true)}>
            Create Book
          </button>
          <button className="assistant-btn" onClick={handleRemoveBook}>
            Remove Book
          </button>
          <button className="assistant-btn" onClick={handleLockBook}>
            Lock Book
          </button>
          <button className="assistant-btn" onClick={handleUnlockBook}>
            Unlock Book
          </button>
        </div>
      )}

      {showCreateModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{editingBookId ? "Edit Book" : "Create New Book"}</h3>
            <div className="form-row">
              <label>Title:</label>
              <input value={title} onChange={(e) => setTitle(e.target.value)} />
            </div>
            <div className="form-row">
              <label>Author:</label>
              <input value={author} onChange={(e) => setAuthor(e.target.value)} />
            </div>
            <div className="form-row">
              <label>Date Published:</label>
              <input type="date" value={datePublished} onChange={(e) => setDatePublished(e.target.value)} />
            </div>
            <div className="form-row">
              <label>ISBN (Optional):</label>
              <input value={isbn} onChange={(e) => setIsbn(e.target.value)} />
            </div>
            <div className="form-row">
              <label>Content:</label>
              <textarea rows="8" value={content} onChange={(e) => setContent(e.target.value)} placeholder="Use double Enter for new page" />
              <div className="page-split-preview">
                {splitContentIntoPages(content).map((page, idx) => (
                  <div key={idx}>
                    <hr />
                    <strong>--- Page {idx + 1} ---</strong>
                    <p>{page}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-buttons">
              <button onClick={handleSaveBook} className="assistant-btn">
                {editingBookId ? "Update Book" : "Save Book"}
              </button>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setEditingBookId(null);
                  setTitle("");
                  setAuthor("");
                  setContent("");
                }}
                className="assistant-btn cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Library;
